/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import Swiper from 'react-id-swiper';
import 'react-id-swiper/src/styles/css/swiper.css';
import { SafePureComponent } from '../../../../utils/SafePureComponent';
import { Icon } from '../../../ui/Icon';
import Card from '../Cards/index';

// import Swiper core and required modules
// import Swiper from 'swiper';

// import 'swiper/swiper-bundle.css';
import * as styles from './index.styles';

export default class Slider extends SafePureComponent {
  myRef = React.createRef();

  swiper = node => (this.swiper = node && node.swiper);
  state = { isBeginning: true, isEnd: false };

  renderCards() {
    const { cards } = this.props;

    return cards.map((data, index) => {
      return (
        <React.Fragment key={index}>
          <Card data={data} />
        </React.Fragment>
      );
    });
  }

  goPrev = () => {
    const { swiper } = this.myRef.current;
    // swiper.autoplay.stop();
    if (swiper) {
      swiper.slidePrev(300);
    }
  };

  goNext = () => {
    const { swiper } = this.myRef.current;
    // swiper.autoplay.stop();
    if (swiper) {
      swiper.slideNext(300);
    }
  };

  onMouseEnter = () => {
    const { swiper } = this.myRef.current;
    if (swiper) {
      swiper.autoplay.stop();
    }
  };

  onMouseLeave = () => {
    const { swiper } = this.myRef.current;
    if (swiper) {
      swiper.autoplay.start();
    }
  };

  onSlideChange = param => {
    try {
      const {
        current: { swiper },
      } = this.myRef;
      if (swiper) {
        this.setState({
          isBeginning: swiper.isBeginning,
          isEnd: swiper.isEnd,
        });
      }
    } catch (error) {
      console.log('** error > ', error);
    }
  };

  safeRender() {
    const { moreStoriesText } = this.props;
    const swiperParams = {
      initialSlide: 0,

      observer: true,
      observeParents: true,

      loop: false,

      spaceBetween: 30,

      width: 295,
      // slidesPerView: 'auto',
      grabCursor: true,
      // speed: 300,
      autoplay: false,
      // autoplay: {
      //   delay: 50000,
      //   disableOnInteraction: true,
      // },
      on: {
        slideChange: this.onSlideChange,
        reachBeginning: this.onSlideChange,
        reachEnd: this.onSlideChange,
      },
    };
    const { isBeginning, isEnd } = this.state;

    return (
      <div
        css={[styles.homepageSlide]}
        // onMouseEnter={this.onMouseEnter}
        // onMouseLeave={this.onMouseLeave}
        aria-hidden="true"
      >
        <div className="morestories">
          <h2>{moreStoriesText.value}</h2>
          <div className="arrow_sec">
            <button
              className="regus-button-prev"
              onClick={this.goPrev}
              css={[isBeginning && styles.inActiveArrow]}
            >
              <Icon name="arrow-left" />
            </button>

            <button
              className="regus-button-next"
              onClick={this.goNext}
              css={[isEnd && styles.inActiveArrow]}
            >
              <Icon name="arrow-right" />
            </button>
          </div>
        </div>
        {/* <div className="shadowslide"></div> */}
        <Swiper ref={this.myRef} {...swiperParams}>
          {this.renderCards()}
        </Swiper>
      </div>
    );
  }
}
